import { isEmpty } from "../../utils/matchers/matchers.js";
import { objectKeysToCamelCase } from "../../utils/object-keys-conversion.js";
//#region src/infrastructure/http-api/axios-api-response-interceptor.ts
/** A binary body is a payload, not a shape: there are no keys to rename, and
*  walking it would replace the body with an empty object. A Blob survives the
*  isEmpty check below by accident (it has no own enumerable keys, so isEmpty
*  calls it empty) — this says so on purpose, and covers ArrayBuffer, which
*  does not get that accident. */
var isBinary = (data) => typeof Blob !== "undefined" && data instanceof Blob || data instanceof ArrayBuffer;
var responseToCamelCase = (response) => {
	const updatedResponse = { ...response };
	if (!isBinary(response.data) && !isEmpty(response.data)) updatedResponse.data = objectKeysToCamelCase(response.data);
	return updatedResponse;
};
//#endregion
export { responseToCamelCase };

//# sourceMappingURL=axios-api-response-interceptor.js.map